import { useEffect, useRef } from "react";
import { MultiStepItemProps } from "@ucl/library";
import {
  PlaidIdentityVerification,
  PlaidIdentityVerificationRef,
} from "./PlaidIdentityVerification";
import { RequireAuth } from "@/lib/auth/RequireAuth";
import { SecondaryButton } from "@ucl/library";

export interface PlaidIdentityVerificationStepProps extends MultiStepItemProps {
  financialApplicationId?: string;
}

export const PlaidIdentityVerificationStep: React.FC<PlaidIdentityVerificationStepProps> = (
  props
) => {
  return (
    <RequireAuth clientType="consumer">
      <PlaidIdentityVerificationStepInner {...props} />
    </RequireAuth>
  );
};

const PlaidIdentityVerificationStepInner: React.FC<PlaidIdentityVerificationStepProps> = (
  props
) => {
  const plaidRef = useRef<PlaidIdentityVerificationRef>(null);

  const handleSubmit = async () => {
    if (plaidRef.current) {
      return await plaidRef.current.hasRunIdvCheck();
    }
    return false;
  };

  useEffect(() => {
    props.registerSubmit?.(async () => {
      return handleSubmit();
    });
  }, []);

  const handleSkip = () => {
    if (props.handleNext) {
      const skipValidation = true;
      props.handleNext(skipValidation);
    }
  };

  return (
    <section className="plaid-identity-verification step-section">
      <div className="plaid-identity-verification__header step-header">
        Identity Verification
      </div>
      <div className="plaid-identity-verification__subtitle step-subtitle">
        We use Plaid to securely verify your identity.
      </div>
      <div className="plaid-identity-verification__content step-content">
        <PlaidIdentityVerification
          ref={plaidRef}
          financialApplicationId={props.financialApplicationId || ""}
        />
      </div>
      <div className="plaid-identity-verification__skip-section">
        <SecondaryButton onClick={handleSkip}>
          Skip for now
        </SecondaryButton>
      </div>
    </section>
  );
};
